// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatItemView_chat__Dz71w {
  padding-left: 30px;
  display: flex;
  width: 100%;
  text-align: left;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  height: 55px;
  background: white;
  border: 0;
  transition: 0.3s background;
}
.ChatItemView_chatPined__9IizW {
  background: #F7F7F7;
}
.ChatItemView_chatActive__lnlA8 {
  transition: 0.2s background;
  background: #E8F2FD !important;
}
.ChatItemView_chat__Dz71w:not(.ChatItemView_chatActive__lnlA8):hover {
  background: #F7F7F7;
}

.ChatItemView_avatar__CBiLP {
  flex-shrink: 0;
  position: relative;
  width: 40px;
}

.ChatItemView_content__Hqzy9 {
  margin-left: 12px;
  min-width: 1px;
  flex-grow: 1;
  height: 100%;
  padding: 0 12px 0 0;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: center;
  border-bottom: 1px solid #E2E2E2;
  opacity: 1;
}
.ChatItemView_content__header__oTV80 {
  display: flex;
  align-items: center;
}
.ChatItemView_content__footer__15bGD {
  margin-top: 4px;
  width: 100%;
  display: flex;
  align-items: center;
}
.ChatItemView_content__footer__15bGD:empty {
  display: none;
}
.ChatItemView_contentHidden__560a5 {
  transition: 0.3s all;
  opacity: 0;
  width: 0;
}

.ChatItemView_spacer__eVpFK {
  flex-grow: 1;
}

.ChatItemView_name__FQoDI {
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: #272A36;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ChatItemView_name__container__EQpe6 {
  min-width: 1px;
  max-width: 100%;
}

.ChatItemView_icon__ijrM1 {
  width: 18px;
  height: 16px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/chats/ChatItemView/ChatItemView.module.scss","webpack://./src/assets/scss/mixins.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,aAAA;EACA,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EAEA,eAAA;EACA,YAAA;EAEA,iBAAA;EACA,SAAA;EACA,2BAAA;AAHF;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,2BAAA;EACA,8BAAA;AALJ;AAQE;EACE,mBAAA;AANJ;;AAUA;EACE,cAAA;EACA,kBAAA;EACA,WAAA;AAPF;;AAWA;EACE,iBAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,uBAAA;EACA,gCAAA;EACA,UAAA;AARF;AAcE;EACE,aAAA;EACA,mBAAA;AAZJ;AAeE;EACE,eAAA;EAEA,WAAA;EACA,aAAA;EACA,mBAAA;AAdJ;AAiBE;EACE,aAAA;AAfJ;AAkBE;EACE,oBAAA;EACA,UAAA;EACA,QAAA;AAhBJ;;AAoBA;EACE,YAAA;AAjBF;;AAqBA;EAME,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EC7FA,mBAAA;EACA,gBAAA;EACA,uBAAA;ADuEF;AAYE;EACE,cAAA;EACA,eAAA;AAVJ;;AAsBA;EACE,WAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;AAnBF","sourcesContent":["@import '@/assets/scss/mixins.scss';\n\n.chat {\n  padding-left: 30px;\n  display: flex;\n  width: 100%;\n  text-align: left;\n  justify-content: flex-start;\n  align-items: center;\n\n  cursor: pointer;\n  height: 55px;\n\n  background: white;\n  border: 0;\n  transition: 0.3s background;\n\n\n  &Pined {\n    background: #F7F7F7;\n  }\n\n  &Active {\n    transition: 0.2s background;\n    background: #E8F2FD !important;\n  }\n\n  &:not(&Active):hover {\n    background: #F7F7F7;\n  }\n}\n\n.avatar {\n  flex-shrink: 0;\n  position: relative;\n  width: 40px;\n}\n\n\n.content {\n  margin-left: 12px;\n  min-width: 1px;\n  flex-grow: 1;\n  height: 100%;\n  padding: 0 12px 0 0;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  justify-content: center;\n  border-bottom: 1px solid #E2E2E2;\n  opacity: 1;\n\n  //&>* {\n  //  flex-shrink: 0;\n  //}\n\n  &__header {\n    display: flex;\n    align-items: center;\n  }\n\n  &__footer {\n    margin-top: 4px;\n\n    width: 100%;\n    display: flex;\n    align-items: center;\n  }\n\n  &__footer:empty {\n    display: none;\n  }\n\n  &Hidden {\n    transition: 0.3s all;\n    opacity: 0;\n    width: 0;\n  }\n}\n\n.spacer {\n  flex-grow: 1;\n  //width: 100%;\n}\n\n.name {\n  &__container {\n    min-width: 1px;\n    max-width: 100%;\n  }\n\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 16px;\n  color: #272A36;\n\n  @include ellipsis;\n}\n\n\n.icon {\n  width: 18px;\n  height: 16px;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n}\n","@mixin ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n@mixin invisible-scroll {\n  overflow: -moz-scrollbars-none;\n  overflow: -moz-hidden-unscrollable;\n  scrollbar-width: none;\n\n  &::-webkit-scrollbar {\n    display: none;\n    width: 0 !important;\n    -ms-overflow-style: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"chat": `ChatItemView_chat__Dz71w`,
	"chatPined": `ChatItemView_chatPined__9IizW`,
	"chatActive": `ChatItemView_chatActive__lnlA8`,
	"avatar": `ChatItemView_avatar__CBiLP`,
	"content": `ChatItemView_content__Hqzy9`,
	"content__header": `ChatItemView_content__header__oTV80`,
	"content__footer": `ChatItemView_content__footer__15bGD`,
	"contentHidden": `ChatItemView_contentHidden__560a5`,
	"spacer": `ChatItemView_spacer__eVpFK`,
	"name": `ChatItemView_name__FQoDI`,
	"name__container": `ChatItemView_name__container__EQpe6`,
	"icon": `ChatItemView_icon__ijrM1`
};
export default ___CSS_LOADER_EXPORT___;
